import axios from "axios";
// import Vue from "vue";
// const vm = new Vue
export function request(config){
        //创建axios实例
        const instance = axios.create({
            
            //本地登录时，用回正式域名，登录成功后再换回！！！！！！！！！！！！！
            // baseURL: 'http://localhost/',    //后台接口地址
            baseURL: 'https://wxadmin.library.bnuzh.edu.cn/',   //后台接口地址

            timeout: 20000,
            // headers: header
        })
        //axios拦截器
        //axios拦截器
        //请求拦截
        instance.interceptors.request.use(config => {
            // console.log(config);
            return config
        },err => {
            console.log(err);
        })
        //响应拦截
        instance.interceptors.response.use(res => {
            if (res.data.code == 10000 ) {
                // console.log(res);
                localStorage.removeItem('token');
                window.location.assign("/login");
            }
            // if (res.data.code == 10000) {
            //     localStorage.removeItem('token')
            //     getlogin()
            // }
            else if(res.data.code == 10001 ) {
                let is_info=true
                window.location.assign("/accountNumber")
                sessionStorage.setItem('is_info',is_info)
            }
            else {
                return res.data
            }
            
        },err => {
            console.log(err);
            // return res.data
            
        })
        //发送网络请求
        return instance(config)
}




// WEBPACK FOOTER //
// ./src/utils/request.js